import { Helmet } from "react-helmet";
import Home from "./routes/Home";
import "./App.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Services from "./routes/Services";
import Footer from "./components/Footer";
import About from "./routes/About";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Career from "./routes/Career";
import Blogs from "./routes/Blogs";
import StartProject from "./routes/startProject";
import Work from "./routes/Portfolio";
import PreLoader from "./components/PreLoader";
import { AnimatePresence } from "framer-motion";
import { ChakraProvider } from "@chakra-ui/react";
import logo from "./assets/logo.svg";
import homeScreen from "./assets/Home/home-page.png";
import ReactGA from "react-ga4";
import Contacts from "./routes/Contact";
import Chatbot from "./components/Chatbot";
import { ReactLenis, useLenis } from "lenis/react";
import Connect from "./components/Connect";
import SignIn from "./components/SignIn";
import { Toaster } from "react-hot-toast";
import MetaPixelEvent from "./utils/MetaPixalEvent";
import Pricing from "./routes/Pricing";
import Checkout from "./routes/Checkout";
import PrivacyModal from "./components/modal/PrivacyModal";
import FAQModal from "./components/modal/RefundModel";
import TermModal from "./components/modal/TermModal";
import Success from "./components/Payment/Success";
import Failure from "./components/Payment/Failure";
import User from "./routes/User";
import { useSelector } from "react-redux";
import Wheel from "./routes/Wheel";

ReactGA.initialize("G-J8FLW4D9MG");

function App() {
  // const lenis = useLenis(({ scroll }) => {});

  const [isPopUp, setPopUp] = useState({ pop: false, count: 0 });
  const { pathname } = useLocation();

  const user = useSelector((state) => state.auth.user);
  useEffect(() => {
    const timeoutId = setTimeout(
      () => {
        if (!user) {
          setPopUp((prevState) => ({ pop: true, count: prevState.count + 1 }));
        }
      },
      pathname === "/work"
        ? 7000
        : pathname === "/checkout" || pathname === "/user"
        ? 0
        : 900000
    );

    return () => {
      clearTimeout(timeoutId);
    };
  }, [pathname, user]);

  return (
    <>
      <MetaPixelEvent />
      <div className={`App `}>
        <Helmet>
          <title>
            Sicu-aura Innoviz | Best Quality Website, Apps, Designing,Digital
            Marketing and SEO Experts in India
          </title>
          <meta
            name="description"
            content="We're your digital growth partners. We listen to your needs and build solutions that work for you. From custom websites and software to powerful SEO, marketing, and design. Let's create a digital strategy that brings your vision to life."
          />
          <meta
            name="keywords"
            content={`
              Big software development companies in INDIA, Big software development companies in US, Big software development companies in Canada, Big software development companies in Europe, Big software development companies in California, Big software development companies in Nigeria, Big software development companies in UK, Best software development companies in INDIA, Best software development companies in US, Best software development companies in Canada, Best software development companies in Europe, TOpt software development companies in California, Best software development companies in UK, Best software development companies in Nigeria, Software Development Company, Custom Software Development,Topsoftware Development, Web Development Services, Software Development Services, Top Software Development Companies, Enterprise Software Development, Software Outsourcing, Software Developers for Hire, Software Development Firm, Software Development Company in Europe, Software Development Company in USA, Software Development Company in UK, Software Development Company in Canada, Software Development Company in Nigeria, Top software development companies in INDIA, Top software development companies in US, Top software development companies in Canada, Top software development companies in Europe, Top software development companies in California, Top software development companies in NigInnoviz, Best Tata consultancy service or TCS Alternatives, HCL Tech Software Review, Switch from Infosys to Sicu-aura Innovizura Innoviz-commerce Development Services, Mobile App Development Company, AI and Machine Learning Development, Blockchain Development Services, IoT Software Development, SaaS Development Company, API Integration Services, Healthcare Software Development, Fintech Software Development, E-commerce Software Solutions, Education Software Development, Real Estate Software Development, Retail Software Development, Automotive Software Solutions, Logistics Software Development, Manufacturing Software Development, Hospitality Software Development, Infosys Alternative, Wipro vs Sicu-aura Innoviz, Best Tata consultancy service or TCS Alternatives, HCL Tech Software Review, Switch from Infosys to Sicu-aura Innoviz, Custom CRM Development Company, Best Software Solutions for Small Businesses 
              sicu-aura Innoviz 
Aura
Sicuaura innovig
Sikuora innoviz
Sisu Aura
Sicauara
Sicaaura
Top website development company
Best website development company
Premium software development company
Top quality website developer
Best Quality Website, Apps, Designing,Digital Marketing and SEO Experts in India
custom software development company 
sicu aura 
sicu-aura 
sicuaura 
web development company
web design company
custom software development company
digital marketing agency
SEO agency
app development company
graphics design company
motion graphics studio
3D design studio
Sicu-aura Innoviz
sicu aura web developer
sicu-aura app developer
sicuaura marketing
esolz
webskitters
designer360
ecommerce feature
features of ecommerce
mass media role
impact of mass media
what is digital marketing agency
role of the mass media
types of agencies
what is digital marketing agencies
search engine optimization companies india
role of the media
role of mass media
roles of mass media
apple music vs spotify
cost for developing a website in india
website designing company delhi
marketing online agency
website design and development companies
website making cost in india
delhi web designing company
Sicu-aura Innoviz 
Software development company in India
Web development company in India
App development company in India
Graphics design company in India
Digital marketing company in India


Software development company in Barrackpore
Web development company in Barrackpore
App development company in Barrackpore
Graphics design company in Barrackpore
Digital marketing company in Barrackpore
Software development company in West Bengal
Web development company in West Bengal
App development company in West Bengal
Graphics design company in West Bengal
Digital marketing company in West Bengal
Custom software development India
Enterprise software development India
Mobile app development India
Web app development India
UI/UX design India
SEO services India
PPC services India
Social media marketing India
Content marketing India
E-commerce development India

Best software development company for Restuarants in India
Top web development companies in Barrackpore
Affordable app development services in West Bengal
Hire freelance graphic designer India
Digital marketing agency for small businesses India

Sicu-aura Innoviz software development company India
Sicu-aura Innoviz web development company India
Sicu-aura Innoviz app development company India
Sicu-aura Innoviz graphics design company India
Sicu-aura Innoviz digital marketing company India
Best software development company in Barrackpore
Best web development company in Barrackpore
Best app development company in Barrackpore
Best graphics design company in Barrackpore
Best digital marketing company in Barrackpore


Software development company Barrackpore West Bengal
Web development company Barrackpore West Bengal
App development company Barrackpore West Bengal
Graphics design company Barrackpore West Bengal
Digital marketing company Barrackpore West Bengal
Software development services in West Bengal
Web development services in West Bengal
App development services in West Bengal
Graphics design services in West Bengal
Digital marketing services in West Bengal
"software development Kolkata"
"web development services Howrah"
"app development company Hooghly"
"graphic design services West Bengal"
"digital marketing agency North 24 Parganas"
Target each service Sicu-aura Innoviz offers:
"Sicu-aura Innoviz software development"
"Sicu-aura Innoviz web design"
"Sicu-aura Innoviz mobile app development"
"Sicu-aura Innoviz graphic design company"
"Sicu-aura Innoviz digital marketing services"
Combine location and services for increased targeting:
"best software development company in Barrackpore"
"e-commerce website development services West Bengal"
"android app development company near me"
"creative graphic design agency Barrackpore"
"affordable SEO services for small businesses India"
Software Development: "Software Development Company India", "Custom Software Development Barrackpore", ".NET Development Services Kolkata" etc.
Web Development: "Web Development Company West Bengal", "Ecommerce Website Development India", "Website Design Services Barrackpore" etc.
App Development: "Mobile App Development Company India", "Android App Development Kolkata", "iOS App Development Services Barrackpore" etc.
Graphic Design: "Graphic Design Services India", "Logo Design Company West Bengal", "UI/UX Design Barrackpore" etc.
Digital Marketing: "Digital Marketing Agency India", "SEO Services Kolkata", "Social Media Marketing Barrackpore" etc.
"What is software development?"
"Benefits of web development for small businesses in India"
"How to choose a mobile app development company in Kolkata" etc.
"benefits of custom software development"
"how to choose a web development company in India"
"cost of app development in West Bengal"
"importance of digital marketing for small businesses"
"graphic design trends for 2024"

Custom software development India
E-commerce website development India
Mobile app development India
Logo design services India
Search engine optimization India
Social media marketing India
https://en.wikipedia.org/wiki/Pay-per-click (PPC) services India
Sicu-aura Innoviz Barrackpore contact number
Sicu-aura Innoviz West Bengal address
Best software development company near me (Barrackpore)
Top web development services in Delhi, Gurgaon, Lucknow, Kolkata, Mumbai, Pune, Kerala, Hyderabad, Bangalore

Best software development company for Landscape Industry in India
Best software development company for Real Estate Industry in India
Best software development company for clinics in India
Best software development company for Retailers in India
Best software development company for educational institute in India
Custom web development services India
E-commerce app development company India
Creative graphic design agency India
SEO services for small businesses India
Restuarant specific digital marketing services India
best web development company in Barrackpore
best web development company in Kolkata
best web development company in Mumbai
best web development company in Delhi
best web development company in Gurugram
best web development company in Noida
best web development company in Bangalore
best web development company in Pune
best web development company in Hyderabad
best web development company in chennai
best web development company in Ahmedabad
best web development company in Surat
best web development company in vellore
best web development company in India
best web development company in Andhra Pradesh
best web development company in Arunachal Pradesh
best web development company in Assam 
best web development company in Bihar
best web development company in Chhattisgarh
best web development company in Goa 
best web development company in Gujarat
best web development company in Haryana
best web development company in Himachal Pradesh
best web development company in Jharkhand
best web development company in Karnataka
best web development company in Kerala
best web development company in Madhya Pradesh
best web development company in Maharastra
best web development company in Manipur
best web development company in Meghalaya
best web development company in Mizoram
best web development company in Nagaland
best web development company in Odisha
best web development company in Punjab
best web development company in Rajasthan
best web development company in Sikkim
best web development company in Tamil Nadu
best web development company in Telangana
best web development company in Tripura
best web development company in Uttar Pradesh
best web development company in Uttarakhand
best web development company in West Bengal
best web development company in Lucknow
best web development company in Chandigarh
best web development company in Bhopal 
affordable web design services in Barrackpore
affordable web design services in Kolkata
affordable web design services in Mumbai
affordable web design services in Delhi
affordable web design services in Gurugram
affordable web design services in Noida
affordable web design services in Bangalore
affordable web design services in Pune
affordable web design services in Hyderabad
affordable web design services in chennai
affordable web design services in Ahmedabad
affordable web design services in Surat
affordable web design services in vellore
affordable web design services in India
affordable web design services in Andhra Pradesh
affordable web design services in Arunachal Pradesh
affordable web design services in Assam 
affordable web design services in Bihar
affordable web design services in Chhattisgarh
affordable web design services in Goa 
affordable web design services in Gujarat
affordable web design services in Haryana
affordable web design services in Himachal Pradesh
affordable web design services in Jharkhand
affordable web design services in Karnataka
affordable web design services in Kerala
affordable web design services in Madhya Pradesh
affordable web design services in Maharastra
affordable web design services in Manipur
affordable web design services in Meghalaya
affordable web design services in Mizoram
affordable web design services in Nagaland
affordable web design services in Odisha
affordable web design services in Punjab
affordable web design services in Rajasthan
affordable web design services in Sikkim
affordable web design services in Tamil Nadu
affordable web design services in Telangana
affordable web design services in Tripura
affordable web design services in Uttar Pradesh
affordable web design services in Uttarakhand
affordable web design services in West Bengal
affordable web design services in Lucknow
affordable web design services in Chandigarh
affordable web design services in Bhopal  
custom software solutions for Hospital
custom software solutions for Research and Development
custom software solutions for Entertainment
custom software solutions for Automobile Engineering
custom software solutions for Home Repairing Industry
custom software solutions for Mobile Developer
custom software solutions for Fintech
custom software solutions for Retail
custom software solutions for Insurance
custom software solutions for Cyber Security
custom software solutions for Internet of Things
custom software solutions for SaaS Software
custom software solutions for Government
custom software solutions for Information Technology
custom software solutions for Big Data
custom software solutions for Web Development
custom software solutions for Education Technology
custom software solutions for EdTech
custom software solutions for Health Technology
custom software solutions for Travel
custom software solutions for Human Resource Management System
custom software solutions for Landscaping
e-commerce website development
mobile app development for Android
mobile app development for Cross Platform
local SEO services in Barrackpore
local SEO services in Kolkata
local SEO services in Mumbai
local SEO services in Delhi
local SEO services in Gurugram
local SEO services in Noida
local SEO services in Bangalore
local SEO services in Pune
local SEO services in Hyderabad
local SEO services in chennai
local SEO services in Ahmedabad
local SEO services in Surat
local SEO services in vellore
local SEO services in India
local SEO services in Andhra Pradesh
local SEO services in Arunachal Pradesh
local SEO services in Assam
local SEO services in Bihar
local SEO services in Chhattisgarh
local SEO services in Goa 
local SEO services in Gujarat
local SEO services in Haryana
local SEO services in Himachal Pradesh
local SEO services in Jharkhand
local SEO services in Karnataka
local SEO services in Kerala
local SEO services in Madhya Pradesh
local SEO services in Maharastra
local SEO services in Manipur
local SEO services in Meghalaya
local SEO services in Mizoram
local SEO services in Nagaland
local SEO services in Odisha
local SEO services in Punjab
local SEO services in Rajasthan
local SEO services in Sikkim
local SEO services in Tamil Nadu
local SEO services in Telangana
local SEO services in Tripura
local SEO services in Uttar Pradesh
local SEO services in Uttarakhand
local SEO services in West Bengal
local SEO services in Lucknow
local SEO services in Chandigarh
local SEO services in Bhopal
website redesign services
logo design and branding
social media marketing agency in Barrackpore
social media marketing agency in Kolkata
social media marketing agency in Mumbai
social media marketing agency in Delhi
social media marketing agency in Gurugram
social media marketing agency in Noida
social media marketing agency in Bangalore
social media marketing agency in Pune
social media marketing agency in Hyderabad
social media marketing agency in chennai
social media marketing agency in Ahmedabad
social media marketing agency in Surat
social media marketing agency in vellore
social media marketing agency in India
social media marketing agency in Andhra Pradesh
social media marketing agency in Arunachal Pradesh
social media marketing agency in Assam 
social media marketing agency in Bihar
social media marketing agency in Chhattisgarh
social media marketing agency in Goa 
social media marketing agency in Gujarat
social media marketing agency in Haryana
social media marketing agency in Himachal Pradesh
social media marketing agency in Jharkhand
social media marketing agency in Karnataka
social media marketing agency in Kerala
social media marketing agency in Madhya Pradesh
social media marketing agency in Maharastra
social media marketing agency in Manipur
social media marketing agency in Meghalaya
social media marketing agency in Mizoram
social media marketing agency in Nagaland
social media marketing agency in Odisha
social media marketing agency in Punjab
social media marketing agency in Rajasthan
social media marketing agency in Sikkim
social media marketing agency in Tamil Nadu
social media marketing agency in Telangana
social media marketing agency in Tripura
social media marketing agency in Uttar Pradesh
social media marketing agency in Uttarakhand
social media marketing agency in West Bengal
social media marketing agency in Lucknow
social media marketing agency in Chandigarh
social media marketing agency in Bhopal
explainer video production
3D product visualization
web development company in Barrackpore
web development company in Kolkata
web development company in Mumbai
web development company in Delhi
web development company in Gurugram
web development company in Noida
web development company in Bangalore
web development company in Pune
web development company in Hyderabad
web development company in chennai
web development company in Ahmedabad
web development company in Surat
web development company in vellore
web development company in India
web development company in Andhra Pradesh
web development company in Arunachal Pradesh
web development company in Assam 
web development company in Bihar
web development company in Chhattisgarh
web development company in Goa 
web development company in Gujarat
web development company in Haryana
web development company in Himachal Pradesh
web development company in Jharkhand
web development company in Karnataka
web development company in Kerala
web development company in Madhya Pradesh
web development company in Maharastra
web development company in Manipur
web development company in Meghalaya
web development company in Mizoram
web development company in Nagaland
web development company in Odisha
web development company in Punjab
web development company in Rajasthan
web development company in Sikkim
web development company in Tamil Nadu
web development company in Telangana
web development company in Tripura
web development company in Uttar Pradesh
web development company in Uttarakhand
web development company in West Bengal
web development company in Lucknow
web development company in Chandigarh
web development company in Bhopal
web design agency near me
web development company near me
social media marketing agency near me
logo design and branding near me
Logo designer near me
local SEO services near me
Business profile SEO near me
custom software solutions near me
affordable web design services near me
best web development company near me
Best Graphics designer near me
digital marketing services in Barrackpore
digital marketing services in Kolkata
digital marketing services in Mumbai
digital marketing services in Delhi
digital marketing services in Gurugram
digital marketing services in Noida
digital marketing services in Bangalore
digital marketing services in Pune
digital marketing services in Hyderabad
digital marketing services in chennai
digital marketing services in Ahmedabad
digital marketing services in Surat
digital marketing services in vellore
digital marketing services in India
digital marketing services in Andhra Pradesh
digital marketing services in Arunachal Pradesh
digital marketing services in Assam 
digital marketing services in Bihar
digital marketing services in Chhattisgarh
digital marketing services in Goa 
digital marketing services in Gujarat
digital marketing services in Haryana
digital marketing services in Himachal Pradesh
digital marketing services in Jharkhand
digital marketing services in Karnataka
digital marketing services in Kerala
digital marketing services in Madhya Pradesh
digital marketing services in Maharastra
digital marketing services in Manipur
digital marketing services in Meghalaya
digital marketing services in Mizoram
digital marketing services in Nagaland
digital marketing services in Odisha
digital marketing services in Punjab
digital marketing services in Rajasthan
digital marketing services in Sikkim
digital marketing services in Tamil Nadu
digital marketing services in Telangana
digital marketing services in Tripura
digital marketing services in Uttar Pradesh
digital marketing services in Uttarakhand
digital marketing services in West Bengal
digital marketing services in Lucknow
digital marketing services in Chandigarh
digital marketing services in Bhopal
SEO consultant in Barrackpore
SEO consultant in Kolkata
SEO consultant in Mumbai
SEO consultant in Delhi
SEO consultant in Gurugram
SEO consultant in Noida
SEO consultant in Bangalore
SEO consultant in Pune
SEO consultant in Hyderabad
SEO consultant in chennai
SEO consultant in Ahmedabad
SEO consultant in Surat
SEO consultant in vellore
SEO consultant in India
SEO consultant in Andhra Pradesh
SEO consultant in Arunachal Pradesh
SEO consultant in Assam 
SEO consultant in Bihar
SEO consultant in Chhattisgarh
SEO consultant in Goa 
SEO consultant in Gujarat
SEO consultant in Haryana
SEO consultant in Himachal Pradesh
SEO consultant in Jharkhand
SEO consultant in Karnataka
SEO consultant in Kerala
SEO consultant in Madhya Pradesh
SEO consultant in Maharastra
SEO consultant in Manipur
SEO consultant in Meghalaya
SEO consultant in Mizoram
SEO consultant in Nagaland
SEO consultant in Odisha
SEO consultant in Punjab
SEO consultant in Rajasthan
SEO consultant in Sikkim
SEO consultant in Tamil Nadu
SEO consultant in Telangana
SEO consultant in Tripura
SEO consultant in Uttar Pradesh
SEO consultant in Uttarakhand
SEO consultant in West Bengal
SEO consultant in Lucknow
SEO consultant in Chandigarh
SEO consultant in Bhopal
web design agency in Germany
web development company in Germany
social media marketing agency in Germany
logo design and branding in Germany
Logo designer in Germany
local SEO services in Germany
Business profile SEO in Germany
custom software solutions in Germany
affordable web design services in Germany
best web development company in Germany
Best Graphics designer in Germany

web design agency in Australia
web development company in Australia
social media marketing agency in Australia
logo design and branding in Australia
Logo designer in Australia
local SEO services in Australia
Business profile SEO in Australia
custom software solutions in Australia
affordable web design services in Australia
best web development company in Australia
Best Graphics designer in Australia


web design agency in China
web development company in China
social media marketing agency in China
logo design and branding in China
Logo designer in China
local SEO services in China
Business profile SEO in China
custom software solutions in China
affordable web design services in China
best web development company in China
Best Graphics designer in China


web design agency in Lithuania
web development company in Lithuania
social media marketing agency in Lithuania
logo design and branding in Lithuania
Logo designer in Lithuania
local SEO services in Lithuania
Business profile SEO in Lithuania
custom software solutions in Lithuania
affordable web design services in Lithuania
best web development company in Lithuania
Best Graphics designer in Lithuania


web design agency in United States , USA
web development company in United States , USA
social media marketing agency in United States , USA
logo design and branding in United States , USA
Logo designer in United States , USA
local SEO services in United States , USA
Business profile SEO in United States , USA
custom software solutions in United States , USA
affordable web design services in United States , USA
best web development company in United States , USA
Best Graphics designer in United States , USA


web design agency in Vilnius
web development company in Vilnius
social media marketing agency in Vilnius
logo design and branding in Vilnius
Logo designer in Vilnius
local SEO services in Vilnius
Business profile SEO in Vilnius
custom software solutions in Vilnius
affordable web design services in Vilnius
best web development company in Vilnius
Best Graphics designer in Vilnius


web design agency in Melbourne
web development company in Melbourne
social media marketing agency in Melbourne
logo design and branding in Melbourne
Logo designer in Melbourne
local SEO services in Melbourne
Business profile SEO in Melbourne
custom software solutions in Melbourne
affordable web design services in Melbourne
best web development company in Melbourne
Best Graphics designer in Melbourne

web design agency in Hanamkonda
web development company in Hanamkonda
social media marketing agency in Hanamkonda
logo design and branding in Hanamkonda
Logo designer in Hanamkonda
local SEO services in Hanamkonda
Business profile SEO in Hanamkonda
custom software solutions in Hanamkonda
affordable web design services in Hanamkonda
best web development company in Hanamkonda
Best Graphics designer in Hanamkonda

web design agency in Ireland
web development company in Ireland
social media marketing agency in Ireland
logo design and branding in Ireland
Logo designer in Ireland
local SEO services in Ireland
Business profile SEO in Ireland
custom software solutions in Ireland
affordable web design services in Ireland
best web development company in Ireland
Best Graphics designer in Ireland


web design agency in Sweden
web development company in Sweden
social media marketing agency in Sweden
logo design and branding in Sweden
Logo designer in Sweden
local SEO services in Sweden
Business profile SEO in Sweden
custom software solutions in Sweden
affordable web design services in Sweden
best web development company in Sweden
Best Graphics designer in Sweden


web design agency in Russia
web development company in Russia
social media marketing agency in Russia
logo design and branding in Russia
Logo designer in Russia
local SEO services in Russia
Business profile SEO in Russia
custom software solutions in Russia
affordable web design services in Russia
best web development company in Russia
Best Graphics designer in Russia


web design agency in Philippines
web development company in Philippines
social media marketing agency in Philippines
logo design and branding in Philippines
Logo designer in Philippines
local SEO services in Philippines
Business profile SEO in Philippines
custom software solutions in Philippines
affordable web design services in Philippines
best web development company in Philippines
Best Graphics designer in Philippines

web design agency in France
web development company in France
social media marketing agency in France
logo design and branding in France
Logo designer in France
local SEO services in France
Business profile SEO in France
custom software solutions in France
affordable web design services in France
best web development company in France
Best Graphics designer in France

web design agency in Nigeria 
web development company in Nigeria
social media marketing agency in Nigeria
logo design and branding in Nigeria
Logo designer in Nigeria
local SEO services in Nigeria
Business profile SEO in Nigeria
custom software solutions in Nigeria
affordable web design services in Nigeria
best web development company in Nigeria
Best Graphics designer in Nigeria

web design agency in Mexico
web development company in Mexico
social media marketing agency in Mexico
logo design and branding in Mexico
Logo designer in Mexico
local SEO services in Mexico
Business profile SEO in Mexico
custom software solutions in Mexico
affordable web design services in Mexico
best web development company in Mexico
Best Graphics designer in Mexico

web design agency in Germany
web development company in Germany
social media marketing agency in  Germany
logo design and branding in Germany
Logo designer in Germany
local SEO services in Germany
Business profile SEO in Germany
custom software solutions in Germany
affordable web design services in Germany
best web development company in Germany
Best Graphics designer in Germany

web design agency in Costa Rica
web development company in Costa Rica
social media marketing agency in Costa Rica
logo design and branding in Costa Rica
Logo designer in Costa Rica
local SEO services in Costa Rica
Business profile SEO in Costa Rica
custom software solutions in Costa Rica
affordable web design services in Costa Rica
best web development company in Costa Rica
Best Graphics designer in Costa Rica

web design agency in Ghana
web development company in Ghana
social media marketing agency in Ghana
logo design and branding in Ghana
Logo designer in Ghana
local SEO services in Ghana
Business profile SEO in Ghana
custom software solutions in Ghana
affordable web design services in Ghana
best web development company in Ghana
Best Graphics designer in Ghana

web design agency in Tindivanam
web development company in Tindivanam
social media marketing agency in Tindivanam
logo design and branding in Tindivanam
Logo designer in Tindivanam
local SEO services in Tindivanam
Business profile SEO in Tindivanam
custom software solutions in Tindivanam
affordable web design services in Tindivanam
best web development company inTindivanam
Best Graphics designer in Tindivanam

`}
          />
          <meta name="author" content="Sicu-aura Innoviz" />
          <meta
            property="og:title"
            content="Sicu-aura Innoviz | Best Quality Website, Apps, Designing,Digital Marketing and SEO Experts in India"
          />
          <meta
            property="og:description"
            content="We're your digital growth partners. We listen to your needs and build solutions that work for you. From custom websites and software to powerful SEO, marketing, and design. Let's create a digital strategy that brings your vision to life."
          />
        </Helmet>
        <ChakraProvider>
          <AnimatePresence mode="wait">
            <>
              <Navbar />
              {isPopUp.pop ? (
                <div className="flex justify-center z-50 fixed bg-[#000000ce] w-full h-full items-center">
                  <SignIn setPopUp={setPopUp} count={isPopUp.count} />
                </div>
              ) : null}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/career" element={<Career />} />
                <Route path="/blog" element={<Blogs />} />
                <Route path="/startProject" element={<StartProject />} />
                <Route path="/work" element={<Work />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/user" element={<User />} />
                <Route
                  path="/success/:merchantTransactionId"
                  element={<Success />}
                />
                <Route path="/failure/:id" element={<Failure />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/privacy" element={<PrivacyModal />} />
                <Route path="/refund" element={<FAQModal />} />
                <Route path="/terms" element={<TermModal />} />
                <Route path="/wheel" element={<Wheel />} />
              </Routes>
            </>
          </AnimatePresence>
        </ChakraProvider>
        <Connect />
        <Chatbot />
        <Toaster
          toastOptions={{
            success: {
              style: {
                background: "#00C5B5",
                color: "white",
              },
            },
            error: {
              style: {
                background: "red",
                color: "white",
              },
            },
          }}
        />
        <Footer />
      </div>
    </>
  );
}

export default App;
